"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Cover =
/*#__PURE__*/
function () {
  function Cover(cover) {
    _classCallCheck(this, Cover);

    this.cover = cover;
    this.container = cover.parentNode;
    this.ratio;
    this.load();
  }

  _createClass(Cover, [{
    key: "load",
    value: function load() {
      var _this = this;

      var src = this.cover.dataset.src;
      var img = new Image();
      img.addEventListener('load', function () {
        _this.cover.src = src;

        _this.listen();
      });
      img.src = src;
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this2 = this;

      this.ratio = this.cover.width / this.cover.height;
      setTimeout(function () {
        _this2.resize();
      }, 0);
      this.cover.classList.add('is-loaded');
      window.addEventListener('resize', function () {
        _this2.resize();
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      var ratio = this.container.clientWidth / this.container.clientHeight;

      if (ratio >= this.ratio) {
        this.cover.style.height = 'auto';
        this.cover.style.width = '100%';
      } else {
        this.cover.style.width = 'auto';
        this.cover.style.height = '100%';
      }
    }
  }]);

  return Cover;
}();

document.addEventListener('DOMContentLoaded', function () {
  var covers = _toConsumableArray(document.getElementsByClassName('js-cover-image'));

  if (covers.length) {
    covers.forEach(function (c) {
      new Cover(c);
    });
  }
});